export { default } from "./ContentDisplayDetails";
